'use client';
import { ScanDates, ScanType, StickyNavigation } from '@/components';
import ClinicLocationsDropdown from '@/components/ClinicLocationsDropdown';
import DiscountRemovalPopup from '@/components/DiscountRemovalPopup/DiscountRemovalPopup';
import { useDiscount, useLocations, useHandleSlots, useDefaultSku, useMarketingData } from '@/hooks';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useShallow } from 'zustand/react/shallow';
import { scrollToElement } from '@/utils/scrollToElement';

export default function ScanDetail() {
  useMarketingData();
  useLocations();
  useDiscount();
  useDefaultSku();

  const handleSlotsData = usePrenuvoStore(
    useShallow((state) => ({
      errorsScanDetails: state.scan.errors,
      setError: state.scan.methods.setError,
      sessionStartTimestamp: state.scan.session?.sessionStartTimestamp,
      eventId: state.scan.eventId,
      location: state.scan.location,
      locationId: state.scan.locationId,
      skuId: state.scan.sku?.skuID,
      machineId: state.scan.machineId,
      currentSlot: state.scan.slot,
      session: state.scan.session,
      discount: state.payment.discount,
      clearScan: state.scan.methods.clearScan,
      setEventId: state.scan.methods.setEventId,
      setErrorModal: state.ui.methods.setErrorModal,
      setSession: state.scan.methods.setSession,
    })),
  );
  const { handleSlots } = useHandleSlots();

  return (
    <div className="container">
      <h1 className="sr-only">Prenuvo Booking Scan Details [Test Staging 1]</h1>
      <div className="mb-6">
        <ClinicLocationsDropdown />
      </div>
      <div className="mb-6">
        <ScanType />
      </div>
      <div className="mb-6">
        <ScanDates />
      </div>
      <DiscountRemovalPopup />
      <StickyNavigation
        onNextPage={() =>
          handleSlots({
            ...handleSlotsData,
            scrollToElement,
          })
        }
      />
    </div>
  );
}
